
// const usuario = 'http://192.168.7.2:80'
// const usuario = 'http://192.168.3.1:8000'
const usuario = 'https://ct.rorlogistico.com/api/usuario'

// const sigestran = 'http://192.168.7.3:80'
// const sigestran = 'http://192.168.3.1:8001'
const sigestran = 'https://ct.rorlogistico.com/api/sigestran'

// const api_checklist = "http://192.168.6.242:8001"
// const api_checklist = "http://192.168.3.1:8001"
const api_checklist = "https://ct.rorlogistico.com/api/checklist"

export default {
    usuario,
    sigestran,
    api_checklist

}